

<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/RevisarTrazabilidad">Revisión de trazabilidad de {{unidad}}</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Revisión de trazabilidad de {{unidad}}</span>
         

          <form id="formPeso" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad v-on:click=usuario() readonly>
            <p id="datetime"></p>
            <input type="text" name="permiso" id="permiso" placeholder="Orden de Sacrificio" v-model=permiso v-on:keyup.enter="ajax()">
             <b-container fluid class="p-4 bg-dark">
  <b-row>
    <b-col><b-img thumbnail fluid  rounded :src="formEditar.fotoreemo"></b-img><p style="color:WHITE">FOTO DE GUÍA</p></b-col>
    <b-col><b-img thumbnail fluid  rounded :src="formEditar.fotofactura"></b-img><p style="color:WHITE">FOTO DE FACTURA</p></b-col>
   <div class="w-100"></div>
    <b-col><b-img thumbnail fluid  rounded :src="formEditar.fotorecibo"></b-img><p style="color:WHITE">FOTO DE RECIBO DE CASETA</p></b-col>
    <b-col><b-img thumbnail fluid  rounded :src="formEditar.fotopermiso"></b-img><p style="color:WHITE">FOTO ORDEN DE SACRIFICIO</p></b-col>
    
  </b-row>
</b-container> 
            <p class="text-break font-weight-bold">
             1. Fecha:  {{formEditar.fechaingreso}} <br>
             2. Especie:  {{formEditar.especie}} <br>
             3. PSG: {{formEditar.psgunidad}} <br>
             4. Reemo: {{formEditar.reemo}} <br>
             5. Factura: {{formEditar.factura}} <br>
             6. Recibo: {{formEditar.recibobovinos}} <br>
             7. Orden de Sacrificio: {{formEditar.permiso}}  <br> 
             8. UPP Origen: {{formEditar.upporigen}} <br>
             9. Localidad: {{formEditar.localidadorigen}} <br>
             10. Municipio: {{formEditar.municipioorigen}} <br>
             11. Estado: {{formEditar.estadoorigen}} <br>
             10. Nombre destinatario: {{formEditar.nombredestino}} <br>
             10. Cantidad: {{formEditar.cantidad}} <br>
             
            
             
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad>
             <input type="hidden" name="fotoForma" id="fotoForma" :value=fotoActual>

           
<div class="card-action">
                        <h6 style="color:Tomato;font-weight:bold;">{{corregir}}</h6>
                        <input type="submit" value="Registrar" :class="boton">
                           
        </div>
            </form>
       

    <b-card-body class="text-center">
     

      <b-card-text>
       <div>
    <h5>Listado del día <br>
    <b-button variant="primary" v-on:click=ajax()>ACTUALIZAR</b-button>
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     @on-cell-click="onCellClick"
     :line-numbers="true"     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.column.field == 'eliminar'">
       
       <b-button variant='danger'>Eliminar</b-button>
     
    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'

import eliminarPesosBovinos from '../mixins/eliminarPesosBovinos'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'RevisarTrazabilidad',  
  data () {
    return {
        mainProps: { blank: true, width: 150, height: 150, class: 'm1' },
        value:1,
         boton:'btn blue disabled',
      msg: 'Número de arete',
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        permiso:'',
        formEditar:{},
        corregir:'',
      columns:[
        {
          label:'id',
          field:'id',
            hidden:true
        },
        {
          label:'Fecha de sacrificio',
          field:'fecha',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd'
        },
        {
          label:'Arete',
          field:'sng'
        },
        {
          label:'Iniciales',
          field:'iniciales'
        },
        {
          label:'Canal',
          field:'canal'
        },
        {
          label:'Serie',
          field:'serie'
        },
        {
          label:'Sexo',
          field:'sexo'
        },
        {
          label:'Peso',
          field:'peso'
        },
        
      ],
      rows:[

      ]
    }
  },
  computed:{
     ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  methods:{
    validarCanal(){
            
                const formData = new FormData()
                formData.append('serie',this.serie)
                formData.append('unidadForma',this.unidad)
                formData.append('canal',this.value)
               /* EN caso de querer mandar más de un dato se repite varias veces y se cambia el nombre y la variable
                FormData.append('correo',this.correo)
                FormData.append('correo',this.correo)*/
                //axios.post('httpss://proyectocdnywebpack.000webhostapp.com/snippetWebpack/api/loginRegistro/validarEmail.php',formData)
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/validarCanal.php',formData)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            this.boton = 'btn blue'
                            this.corregir=''
                        } else {
                            this.boton = 'btn blue disabled'
                            this.corregir='El canal indicado ya está registrado'
                            swal({
                    title:'El canal indicado ya está registrado',
                    icon: 'error'}) 
                        }
                    })
    },
    getId(){
           //this.usuario()

            const id = this.idver
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getBitacora1.php?id='+id)
            
                .then(response=>{
                   
                    this.formEditar = response.data
                  
                    //this.selected=this.formEditar.perfil
                })
                   
        },

     onCellClick(params) {
         if(params.column.field=="eliminar"){
         this.eliminarPesosBovinos(params.row.id)
         this.ajax()
         }
         else{
            this.idver= params.row.id
           setTimeout(() => {  this.getId(); }, 500)
        this.ajax()
         }
         //
   // alert (params.row.id) // params.row - row object   /// 
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajaxdelay(){
     setTimeout(() => {  this.ajax(); }, 2500)
    },
    ajax(){
      //this.getId()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     const permisoQuery = this.permiso
     const unidadquery=this.unidad
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getTrazabilidadOS.php?permiso='+permisoQuery+'&unidad='+unidadquery)
      .then(response=>{
        this.rows=response.data
        
      })
    axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getTrazabilidadOS1.php?permiso='+permisoQuery+'&unidad='+unidadquery)
      .then(res=>{
        this.formEditar=res.data
        
      })
    },
    usuario(){
       // this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     this.usuariolocal= result
     const tok=this.usuariolocal
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    this.validarCanal()
    },
    editar(){
      if(this.boton == 'btn blue disabled'){

            }
            else{
            //this.usuario()
             const form=document.getElementById('formPeso')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarPeso.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                       this.ajax()
                    this.ticketIncremento()
                        document.getElementById("peso").value=""
                      document.getElementById("peso").focus()
                       //swal('El registro fue editado')
                        //this.$router.push('/inicio')
                        
                    } else {
                        swal('El registro no pudo ser editado'+res.data)
                    }
                })
            }
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
    
    setTimeout(() => {  this.usuario(); }, 500)
    setTimeout(() => {  this.ajax(); }, 1500)
  },
  components:{
    Cabecera,
    Menu
  },
  mixins:[sesion,eliminarPesosBovinos]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RevisarTrazabilidad.vue